import styled from 'styled-components';
import media from '../../../styles/media.style';

export const Container = styled.div`
  position: relative;
  width: 100vw;
  overflow-x: hidden;
`;
export const Items = styled.ul`
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  width: 400vw;
  overflow-x: hidden;
  transition-property: left;
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  transition-delay: 0;
  &.top {
    left: 0;
  }
  &.care {
    left: -100vw;
  }
  &.home-care {
    left: -200vw;
  }
  &.confirm {
    left: -300vw;
  }
`;
export const Item = styled.li`
  width: 100vw;
  overflow: hidden;
  height: 100vh;
  list-style: none;

  &.current {
    overflow: visible;
    height: auto;
  }
`;
export const PlaceholderWrapper = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  width: 540px;
  max-width: 100%;
  padding: 0;
  margin: 0;

  ${media.tabletP`
    top: 113px;
    width: 100%;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/SublimicDiagnosisResultPage.style.js